export default __webpack_public_path__ + "static/media/addCompany.ba193501.png";